import { Tel } from "#app/_ui/components/media/Tel";
import { hoursOnlineSupport, telOnlineSupport } from "#app/lib/company";
import { toUsaTelHref } from "#app/lib/telephone";
import { Alert, AlertContent, AlertDescription, AlertTitle } from "#ui/alert";
import { Card, CardContent } from "#ui/card";
import { Icon } from "#ui/icon";
import { Link } from "#ui/link";
import { H2, P } from "#ui/typography";

export function RegisterClientStep1({ email }: { email: string }) {
  return (
    <div className="space-y-30px">
      <Card variant="white-border-and-blur">
        <CardContent>
          <div className="flex flex-col items-center gap-15px p-20px text-center">
            <Icon
              name="baird-checkmark-circle"
              size="baird-lg"
              palette="success"
              className="mb-5px"
            />
            <H2 size="h5" className="leading-none">
              Check your email
            </H2>
            <div>
              <P size="sm" palette="neutral-subtle">
                An email confirmation has been sent to{" "}
                <span className="font-semibold">{email}</span>.
              </P>
              <P size="sm" palette="neutral-subtle">
                Please click the verification link to continue the registration
                process. The link will be valid for{" "}
                <strong className="font-semibold">4 hours</strong>.
              </P>
            </div>
          </div>
        </CardContent>
      </Card>

      <Alert intent="warning" className="*:*:inline *:*:pe-4px">
        <AlertContent>
          <AlertTitle>Help and Troubleshooting:</AlertTitle>
          <AlertDescription>
            If you are not receiving these notifications, be sure to check your
            &ldquo;Junk Mail&rdquo; or &ldquo;Spam&rdquo; folder in case your
            email service is flagging the message as spam. For additional
            assistance contact{" "}
            <Link href="/tech-support" target="_blank">
              Online Support
            </Link>{" "}
            or call{" "}
            <Tel href={telOnlineSupport} hrefFn={toUsaTelHref}>
              {telOnlineSupport}
            </Tel>
            , {hoursOnlineSupport}.
          </AlertDescription>
        </AlertContent>
      </Alert>
    </div>
  );
}
